import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import Logo from "./Logo";

const PageHeader = ({ currentPage, currentSubPage, mobileMenuOpen, setMobileMenuOpen }) => {
  const location = useLocation();
  
  // Map routes to main menu items
  const getMainMenuItem = () => {
    const path = location.pathname;
    if (path === '/dashboard') return { icon: 'fa-chart-line', label: 'Dashboard' };
    if (path === '/call-logs') return { icon: 'fa-clock-rotate-left', label: 'Call Logs' };
    if (path === '/bookings') return { icon: 'fa-calendar', label: 'Bookings' };
    if (path === '/objectives') return { icon: 'fa-crosshairs', label: 'Objectives' };
    if (path === '/analytics') return { icon: 'fa-chart-bar', label: 'Analytics' };
    if (path === '/referrals') return { icon: 'fa-gift', label: 'Referrals' };
    if (path === '/skills') return { icon: 'fa-cogs', label: 'Skills' };
    if (path === '/plans') return { icon: 'fa-credit-card', label: 'Plans' };
    if (path.startsWith('/settings')) return { icon: 'fa-cog', label: 'Settings' };
    if (path.startsWith('/logs')) return { icon: 'fa-file-text', label: 'Logs' };
    return { icon: 'fa-chart-line', label: 'Dashboard' };
  };

  const mainItem = getMainMenuItem();
  
  return (
    <div className="mb-8">
      <div className="flex items-center justify-between mb-4">
        {/* Mobile logo and name */}
        <Link to="/dashboard" className="md:hidden flex items-center gap-2">
         <Logo width="40" height="40" mobile={true} />
          <span className="text-lg font-bold text-gray-800">Remote Assistant</span>
        </Link>
        
        {/* Mobile hamburger menu */}
        <button 
          className="md:hidden p-2" 
          onClick={() => setMobileMenuOpen && setMobileMenuOpen(!mobileMenuOpen)}
        >
          <i className="fa fa-bars text-xl text-gray-600"></i>
        </button>
        
        {/* Desktop breadcrumb */}
        <div className="hidden md:flex items-center gap-4">
          <div className="flex items-center gap-3">
            <i className={`fa ${mainItem.icon} text-2xl text-blue-600`}></i>
            <span className="text-lg font-medium text-gray-700">{mainItem.label}</span>
          </div>
          {currentSubPage && (
            <>
              <div className="w-px h-8 bg-gray-300"></div>
              <div className="flex items-center gap-3">
                <i className={`fa ${currentSubPage.icon} text-lg text-blue-600`}></i>
                <span className="text-lg font-medium text-gray-700">{currentSubPage.label}</span>
              </div>
            </>
          )}
        </div>
      </div>
      <div className="w-full h-px bg-gray-200"></div>
    </div>
  );
};

export default PageHeader;